import styled from 'styled-components';

export const RightBodyWrapper = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
`;

interface MenuViewWrapperProps {
    stacked?: boolean;
}

export const MenuViewWrapper = styled.div<MenuViewWrapperProps>`
    flex: 1 1;
    display: flex;
    flex-direction: row;
    ${(props) => props.stacked && 'flex-direction: column;'}
`;

export const CardTitleElement = styled.h4`
    font-weight: 600;
    margin-top: 0;
    margin-bottom: 16px;
`;

export const HeaderButtonWrapper = styled.div`
    display: flex;
    width: 100%;
    margin-left: -12px;
    margin-bottom: 8px;
    align-items: center;
    font-size: 16px;
`;

export const RowFormElement = styled.div`
    display: flex;
`;
